import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEmail$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEmail extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b38c36c533753afcdfafeb8e2448beb19fc9770d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '45759207a00884c7668cbc12be1e430047bd8c7b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '99f7679851702ae87a8e73002a3959e97a46673f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5m15.16 1-6.17 5-6.17-5zM3.5 16.5V6.36l7.18 5.77a.52.52 0 0 0 .63 0l7.19-5.78V16.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-email", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-email"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-email":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEmail$1);
            }
            break;
    } });
}

const CosmosIconEmail = CosmosIconEmail$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEmail, defineCustomElement };
